import React from 'react';
import SearchResults from './SearchResults';

const Landing = props => {
  return <SearchResults />;
};

export default Landing;
